import { POSITION, useToast } from 'vue-toastification'
import { AxiosError } from 'axios'
import { ErrorResponseData } from '@/types'

const toast = useToast()

const DEFAULT_ERROR_MESSAGE = 'Ошибка загрузки данных'

// Красный тост с крестиком для ошибок
export const showRequestErrorToast = (error: AxiosError<ErrorResponseData>) => {
  const message =
    error.response?.status === 500
      ? DEFAULT_ERROR_MESSAGE
      : error.response?.data?.message || DEFAULT_ERROR_MESSAGE

  toast.error(message, {
    position: POSITION.BOTTOM_RIGHT,
    closeButton: 'button',
  })
}
0
// Красный тост без крестика, исчезает через 5 секунд
export const showRequestErrorToastNoClose = (
  error: AxiosError<ErrorResponseData>,
  defaultMessage: string = DEFAULT_ERROR_MESSAGE,
) => {
  const message =
    error.response?.status === 500
      ? defaultMessage
      : error.response?.data?.message || defaultMessage

  toast.error(message, {
    position: POSITION.BOTTOM_RIGHT,
    closeButton: false,
    timeout: 5000,
  })
}
